var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#D8EEF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M41.281 24.781a9.282 9.282 0 11-18.563 0 9.282 9.282 0 0118.563 0z",
    fill: "#028BB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 36.125h-3.551a11.221 11.221 0 01-9.398 0H23.75a8.25 8.25 0 00-8.25 8.25v1.031a3.094 3.094 0 003.094 3.094h26.812a3.094 3.094 0 003.094-3.094v-1.031a8.25 8.25 0 00-8.25-8.25z",
    fill: "#028BB7"
  })));
}

export default SvgUserAlt;